import axios from '../../Helpers/Axiosbase';
import * as actionTypes from './ActionTypes';
var md5 = require('md5');

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

export const authSuccess = (userId, token, isAdmin, environments, isSessionValid, defaultEnvironment) => {
    localStorage.setItem('userId', userId);
    localStorage.setItem('token', token);
    localStorage.setItem('isAdmin', isAdmin);
    localStorage.setItem('environments', JSON.stringify(environments));
    localStorage.setItem('isSessionValid', isSessionValid);
    localStorage.setItem('defaultEnvironment', defaultEnvironment);
    return {
        type: actionTypes.AUTH_SUCCESS,
        token: token,
        userId: userId,
        isAdmin: isAdmin,
        environments: environments,
        isSessionValid: isSessionValid,
        defaultEnvironment: defaultEnvironment
    };
};

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const auth = (loginDetails) => {
    return dispatch => {
        // dispatch(authStart());
        let url = 'userLogin';
        // loginDetails.password=md5(loginDetails.password);
        axios.post(url, loginDetails)
            .then(response => {
                // console.log(response);
                if (response.data && response.data.responseCode) {
                    if (response.data.responseCode === 200) {
                        // console.log(response);
                        let userId = response.data.response._id;
                        let token = response.data.response.apiAccessToken;
                        let isAdmin = response.data.response.isAdmin;
                        let environments = response.data.response.environments.value;
                        let isSessionValid = true;
                        let defaultEnvironment = response.data.response.defaultEnvironment;
                        dispatch(authSuccess(userId, token, isAdmin, environments, isSessionValid, defaultEnvironment));
                    }
                    else {
                        dispatch(authFail("Login Failed : Invalid Username or Password"));
                    }
                }
            })
            .catch(err => {
                console.log("Error:",err);
                dispatch(authFail("Login Failed:Invalid Username or Password"));
            });
    };
};

export const authLogout = () => {
    localStorage.removeItem('userId');
    localStorage.removeItem('token');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('environments');
    localStorage.removeItem('isSessionValid');
    localStorage.removeItem('selectedApp');
    localStorage.removeItem('selectedComponent');
    localStorage.removeItem('allcomponent');
    localStorage.removeItem('defaultEnvironment');
    localStorage.removeItem('selectedConfiguration');
    localStorage.removeItem('selectedEnvironment');
    localStorage.removeItem('selectedConfigurationForBulkCopy');
    localStorage.removeItem('attributeList');
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};


export const checkAuthStatus = () => {
    return dispatch => {
        let userId = localStorage.getItem('userId');
        let token = localStorage.getItem('token');
        let isAdmin = localStorage.getItem('isAdmin');
        var environments = JSON.parse(localStorage.getItem('environments'));
        // const environments = localStorage.getItem('environments');
        let isSessionValid = localStorage.getItem('isSessionValid');
        let defaultEnvironment = localStorage.getItem('defaultEnvironment');
       
        if (userId) {
            dispatch(authSuccess(userId, token, isAdmin, environments, isSessionValid, defaultEnvironment));
        }
    }
}